document.addEventListener("DOMContentLoaded",function(){
(function(){
  document.querySelectorAll(".rk-lenses").forEach(function(track){
    var down=false,startX=0,startL=0,moved=false;
    track.addEventListener("mousedown",function(e){down=true;moved=false;startX=e.pageX;startL=track.scrollLeft;track.style.scrollSnapType="none";track.style.cursor="grabbing";e.preventDefault();});
    window.addEventListener("mousemove",function(e){if(!down)return;var dx=e.pageX-startX;if(Math.abs(dx)>3)moved=true;track.scrollLeft=startL-dx;});
    window.addEventListener("mouseup",function(){if(!down)return;down=false;track.style.cursor="";var w=track.clientWidth,i=Math.round(track.scrollLeft/(w*.86));track.style.scrollSnapType="";if(moved)track.scrollTo({left:i*(w*.86),behavior:"smooth"});});
    track.addEventListener("click",function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
  });
})();
(function(){
  var lb=document.getElementById("rk-lightbox");if(!lb)return;
  var img=lb.querySelector("img"),cap=lb.querySelector("figcaption");
  function close(){lb.classList.remove("is-open");document.body.style.overflow="";img.removeAttribute("src");}
  document.querySelectorAll(".rk-hl-photo").forEach(function(btn){
    btn.addEventListener("click",function(){
      var inner=btn.querySelector("img");
      var chosen=btn.getAttribute("data-lightbox-src")||(inner?inner.src:"");
      if(chosen){img.setAttribute("src",chosen);}else{return;}
      cap.textContent=btn.getAttribute("data-lightbox-cap")||"";
      lb.classList.add("is-open");document.body.style.overflow="hidden";
    });
  });
  lb.addEventListener("click",function(e){if(e.target===lb||e.target.classList.contains("rk-lightbox-close")||e.target===img)close();});
  window.addEventListener("keydown",function(e){if(e.key==="Escape")close();});
})();
});
